import React, {useContext} from 'react';
import Header from './Components/Header';
import styles from './index.module.scss';
import Page from './Components/Page';
import {Aside} from './Components/Aside';
import {MainAppContext} from '../../AppWrapper/context';
import {SpaceWrapper} from './Components/SpaceWrapper';
import useStorage from 'Utils/Hooks/useStorage';
import {goLogin} from 'Utils/common';
import {Outlet} from 'react-router-dom';
import {AppMenuItem} from '../../../MainMenu';
import {Spin} from 'antd';
import Boundary from '../../Boundary';

function MainLayout() {
    const [token] = useStorage('token');
    const {menuItems} = useContext(MainAppContext);

    function filterMenu(data: any[]): AppMenuItem[] {
        if (!data) {
            return [];
        }
        return data
            ?.filter(item => item.handle?.showNav)
            ?.map(item => {
                return {
                    ...item,
                    children: item.children
                        ? filterMenu(item.children)
                        : undefined,
                };
            });
    }

    const filteredMenu = filterMenu(menuItems[0].children!);

    if (!token) {
        goLogin();
        return null;
    }
    return (
        <div className={styles.root}>
            <Header />

            <div className={styles.body}>
                <Aside menuItems={filteredMenu} />

                <div className={styles.main} id="ROOT_MAIN">
                    <Boundary
                        className={styles.error}
                        spinner={
                            <div className={styles.spinner}>
                                <Spin />
                            </div>
                        }>
                        <Outlet />
                    </Boundary>
                </div>
            </div>
        </div>
    );
}

MainLayout.Page = Page;
MainLayout.SpaceWrapper = SpaceWrapper;

export default MainLayout;
